define('enums/outbound/CampaignStatuses',[], function () {
    'use strict';
    return {
        ON: 'on',
        OFF: 'off',
        STOPPING: 'stopping',
        COMPLETE: 'complete',
        INVALID: 'invalid'
    };
});
